import React from 'react';

import { CheckCircleFilled, UserOutlined } from '@ant-design/icons';
import { Avatar, Empty, List } from 'antd';
import classNames from 'classnames';

import { EMPTY_MESSAGES } from '@/shared/lib/constants';
import { Button } from '@/shared/ui/Button';
import { LoadingState } from '@/shared/ui/states/LoadingState';

import type { ExpertEditHook } from '@/features/domain/model';

import styles from './ExpertEditPopover.module.css';

export type ExpertEditPopoverProps = {
  expertEdit: ExpertEditHook;
};

export const ExpertEditPopover: React.FC<ExpertEditPopoverProps> = ({ expertEdit }) => {
  const {
    users,
    selectedUserIds,
    currentExperts,
    isLoadingUsers,
    isUpdating,
    hasChanges,
    handleUserSelect,
    handleUpdate,
    handleClose,
  } = expertEdit;

  return (
    <div className={styles.popover}>
      <div className={styles.header}>
        <h4 className={styles.title}>사용자 {users.length}</h4>
      </div>
      <div className={styles.listContainer}>
        {isLoadingUsers ? (
          <LoadingState message="" size={32} />
        ) : users.length > 0 ? (
          <List<{ id: string; name: string; displayName?: string }>
            dataSource={users}
            renderItem={(user) => {
              const isSelected = selectedUserIds.includes(user.id);
              const isExisting = currentExperts.some((expert) => expert.id === user.id && expert.type === 'user');
              return (
                <List.Item
                  onClick={() => handleUserSelect(user.id, !isSelected)}
                  className={classNames('listItem', styles.listItem, {
                    selected: isSelected && !isExisting,
                    existing: isSelected && isExisting,
                  })}>
                  <div className={styles.listItemContent}>
                    <Avatar icon={<UserOutlined />} size={24} />
                    <span>{user.displayName || user.name}</span>
                  </div>
                  {isSelected && <CheckCircleFilled className={styles.checkIcon} />}
                </List.Item>
              );
            }}
          />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={EMPTY_MESSAGES.NO_USERS} />
        )}
      </div>
      <div className={styles.actions}>
        <div className={styles.buttonGroup}>
          <Button variant="filled" color="standard" onClick={handleUpdate} loading={isUpdating} disabled={!hasChanges}>
            업데이트
          </Button>
          <Button variant="outlined" color="standard" onClick={handleClose}>
            취소
          </Button>
        </div>
      </div>
    </div>
  );
};
